// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-button{display:inline-flex;align-items:center;justify-content:center}.base-button i{padding:0 3px}", ""]);
// Exports
module.exports = exports;
